import React, { Component, Fragment } from 'react'
import { Form } from 'antd'
import EmailList from '../../People/Member/Common/Contacts/EmailList'
import MobileList from '../../People/Member/Common/Contacts/MobileList'
import PhoneList from '../../People/Member/Common/Contacts/PhoneList'
import AddressList from '../../People/Member/Common/Contacts/AddressList'

const FormItem = Form.Item

class ContactDetails extends Component {
  render() {
    const { getFieldDecorator } = this.props.form
    const { handleChange, contact, handleDefault, handleRemove, handleAdd } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    return (
      <Fragment>
        <EmailList
          list={contact.email}
          handleChange={handleChange}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />
        <MobileList
          list={contact.mobile}
          handleChange={handleChange}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />
        <PhoneList
          list={contact.phone}
          handleChange={handleChange}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />
        <AddressList
          list={contact.address}
          handleChange={handleChange}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />
      </Fragment>
    )
  }
}

const ContactDetailsForm = Form.create()(ContactDetails)

export default ContactDetailsForm

// export default Contact
